import {Heading, HStack, Text, useTheme, VStack} from '@chakra-ui/react'
import dynamic from 'next/dynamic'
import {useRouter} from 'next/router'
import {ROUTE_ROOT} from '../../constants/routes'
import {ServiceGroup} from '../../dataModels/Service'
import {useIsMobile} from '../../hooks/useIsMobile'
import BackButton from '../Molecules/BackButton'
import useTranslation from 'next-translate/useTranslation'

const ServiceBadge = dynamic(() => import('../Molecules/ServiceBadge'))

interface Props {
  serviceGroup: ServiceGroup
}

const ServiceHeader = ({serviceGroup}: Props) => {
  const theme = useTheme()
  const router = useRouter()
  const isMobile = useIsMobile()

  const {t} = useTranslation('service-group')

  return (
    <HStack w='full' h={14} mb={5} justify='space-between'>
      <HStack spacing={5}>
        <BackButton onClick={() => router.replace(ROUTE_ROOT)} />
        {!isMobile && <ServiceBadge icon={serviceGroup.icon} color={serviceGroup.color} />}
        <VStack w='full'>
          <Heading as='h1' color={theme.colors.text.basic} variant='large' w='full'>
            {/* @ts-ignore*/}
            {t(serviceGroup.title)}
          </Heading>
          <Text variant='medium' color={theme.colors.text.light} w='full'>
            {/* @ts-ignore*/}
            {t(serviceGroup.description)}
          </Text>
        </VStack>
      </HStack>
    </HStack>
  )
}

export default ServiceHeader
